import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const iconStyle = {
  padding: `5px`,
  width: `30px`,
  height: `30px`,
  margin: `auto`,
  display: `block`,
}

const profileStyle = {
  borderRadius: `50%`,
  padding: `5px`,
  width: `240px`,
  height: `240px`,
  margin: `auto`,
  display: `block`,
}

const Image = props => {
  const data = useStaticQuery(graphql`
    query {
      profileImage: file(relativePath: { eq: "profile-photo.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mailImage: file(relativePath: { eq: "social-media/mail.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      githubImage: file(relativePath: { eq: "social-media/github.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      linkedinImage: file(relativePath: { eq: "social-media/linkedin.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      twitterImage: file(relativePath: { eq: "social-media/twitter.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      youtubeImage: file(relativePath: { eq: "social-media/youtube.png" }) {
        childImageSharp {
          fluid(maxWidth: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  switch (props.name) {
    case "profile":
      return (
        <Img
          style={profileStyle}
          fluid={data.profileImage.childImageSharp.fluid}
        />
      )
    case "mail":
      return (
        <Img style={iconStyle} fluid={data.mailImage.childImageSharp.fluid} />
      )
    case "github":
      return (
        <Img style={iconStyle} fluid={data.githubImage.childImageSharp.fluid} />
      )
    case "linkedin":
      return (
        <Img
          style={iconStyle}
          fluid={data.linkedinImage.childImageSharp.fluid}
        />
      )
    case "twitter":
      return (
        <Img
          style={iconStyle}
          fluid={data.twitterImage.childImageSharp.fluid}
        />
      )
    case "youtube":
      return (
        <Img
          style={iconStyle}
          fluid={data.youtubeImage.childImageSharp.fluid}
        />
      )
    default:
      return null
  }
}
export default Image
